import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import api from '../services/api';
import { useToast } from '../hooks/useToast';

const إعداداتطرقالدفع = () => {
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingMethod, setEditingMethod] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    const [newMethod, setNewMethod] = useState({
        name: '',
        type: 'OTHER',
        displayNameAr: '',
        displayNameEn: '',
        icon: '',
        displayOrder: 1,
        config: '{}'
    });
    const { showToast, ToastContainer } = useToast();

    useEffect(() => {
        fetchPaymentMethods();
    }, []);

    const fetchPaymentMethods = async () => {
        try {
            setLoading(true);
            const data = await api.getAllPaymentMethods();
            setPaymentMethods(data || []);
        } catch (error) {
            console.error('Error fetching payment methods:', error);
            showToast('حدث خطأ في جلب طرق الدفع', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = async (id) => {
        try {
            await api.togglePaymentMethod(id);
            showToast('تم تحديث الحالة بنجاح', 'success');
            fetchPaymentMethods();
        } catch (error) {
            console.error('Error toggling payment method:', error);
            showToast('حدث خطأ في تحديث الحالة', 'error');
        }
    };

    const handleEdit = (method) => {
        setEditingMethod({ ...method });
    };

    const handleAddNew = () => {
        setNewMethod({
            name: '',
            type: 'OTHER',
            displayNameAr: '',
            displayNameEn: '',
            icon: '',
            displayOrder: paymentMethods.length + 1,
            config: '{}'
        });
        setIsAdding(true);
    };

    const handleSaveNew = async (e) => {
        e.preventDefault();
        let config = {};
        try {
            config = JSON.parse(newMethod.config);
        } catch (e) {
            showToast('خطأ في صيغة الـ JSON في بيانات الربط', 'error');
            return;
        }

        try {
            await api.createPaymentMethod({
                ...newMethod,
                name: newMethod.displayNameEn.toLowerCase().replace(/\s+/g, '_'),
                config
            });
            showToast('تم إضافة طريقة الدفع بنجاح', 'success');
            setIsAdding(false);
            fetchPaymentMethods();
        } catch (error) {
            console.error('Error creating payment method:', error);
            showToast('حدث خطأ في إضافة طريقة الدفع', 'error');
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        let config = editingMethod.config;
        if (typeof config === 'string' && config.trim() !== '') {
            try {
                config = JSON.parse(config);
            } catch (e) {
                showToast('خطأ في صيغة الـ JSON في بيانات الربط', 'error');
                return;
            }
        }

        try {
            await api.updatePaymentMethod(editingMethod.id, {
                displayNameAr: editingMethod.displayNameAr,
                displayNameEn: editingMethod.displayNameEn,
                icon: editingMethod.icon,
                displayOrder: parseInt(editingMethod.displayOrder),
                config: config || {},
            });
            showToast('تم تحديث بيانات طريقة الدفع', 'success');
            setEditingMethod(null);
            fetchPaymentMethods();
        } catch (error) {
            console.error('Error updating payment method:', error);
            showToast('حدث خطأ في تحديث البيانات', 'error');
        }
    };

    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#2B2F3F',
            overflow: 'hidden',
            direction: 'rtl'
        }}>
            <Header />
            <div style={{
                flex: 1,
                padding: '32px',
                backgroundColor: '#2B2F3F',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px'
                }}>
                    <h1 style={{
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '24px',
                        fontWeight: 700,
                        color: '#FFFFFF',
                        margin: 0,
                        textAlign: 'right'
                    }}>
                        إعدادات طرق الدفع
                    </h1>
                    <button
                        onClick={handleAddNew}
                        style={{
                            backgroundColor: '#3FB984',
                            color: '#FFFFFF',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            fontFamily: 'Cairo, sans-serif',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <span>+ إضافة وسيلة دفع جديدة</span>
                    </button>
                </div>

                <div style={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '16px',
                    padding: '24px',
                    border: '1px solid rgba(233, 106, 58, 0.15)',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
                    overflow: 'auto'
                }}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#666A7A' }}>جاري التحميل...</div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'Cairo, sans-serif' }}>
                            <thead>
                                <tr style={{ borderBottom: '2px solid #E5E7EB' }}>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>النوع</th>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>الاسم المعروض (عربي)</th>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>الحالة</th>
                                    <th style={{ padding: '12px', textAlign: 'right' }}>الترتيب</th>
                                    <th style={{ padding: '12px', textAlign: 'center' }}>إجراءات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paymentMethods.map((method) => (
                                    <tr key={method.id} style={{ borderBottom: '1px solid #E5E7EB' }}>
                                        <td style={{ padding: '12px', fontWeight: 'bold', color: '#E96A3A' }}>{method.type}</td>
                                        <td style={{ padding: '12px' }}>{method.displayNameAr}</td>
                                        <td style={{ padding: '12px' }}>
                                            <button
                                                onClick={() => handleToggle(method.id)}
                                                style={{
                                                    padding: '4px 12px',
                                                    borderRadius: '8px',
                                                    backgroundColor: method.isEnabled ? '#3FB98420' : '#E96A3A20',
                                                    color: method.isEnabled ? '#3FB984' : '#E96A3A',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontWeight: 600,
                                                    fontSize: '12px'
                                                }}
                                            >
                                                {method.isEnabled ? 'مفعل' : 'معطل'}
                                            </button>
                                        </td>
                                        <td style={{ padding: '12px' }}>{method.displayOrder}</td>
                                        <td style={{ padding: '12px', textAlign: 'center' }}>
                                            <button
                                                onClick={() => handleEdit(method)}
                                                style={{
                                                    backgroundColor: '#4A90E2',
                                                    color: '#FFF',
                                                    border: 'none',
                                                    padding: '6px 12px',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                إعدادات الربط
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                {editingMethod && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}>
                        <div style={{
                            backgroundColor: '#FFF',
                            borderRadius: '16px',
                            padding: '24px',
                            width: '500px',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                        }}>
                            <h2 style={{ fontFamily: 'El Messiri', marginBottom: '20px', color: '#2B2F3F' }}>إعدادات {editingMethod.displayNameAr}</h2>
                            <form onSubmit={handleUpdate} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>الاسم (عربي)</label>
                                        <input
                                            type="text"
                                            value={editingMethod.displayNameAr}
                                            onChange={(e) => setEditingMethod({ ...editingMethod, displayNameAr: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>الاسم (إنجليزي)</label>
                                        <input
                                            type="text"
                                            value={editingMethod.displayNameEn}
                                            onChange={(e) => setEditingMethod({ ...editingMethod, displayNameEn: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            required
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '12px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>أيقونة (URL)</label>
                                        <input
                                            type="text"
                                            value={editingMethod.icon || ''}
                                            onChange={(e) => setEditingMethod({ ...editingMethod, icon: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>الترتيب</label>
                                        <input
                                            type="number"
                                            value={editingMethod.displayOrder}
                                            onChange={(e) => setEditingMethod({ ...editingMethod, displayOrder: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            required
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    marginTop: '12px',
                                    padding: '16px',
                                    backgroundColor: '#F9FAFB',
                                    borderRadius: '12px',
                                    border: '1px dashed #CBD5E0'
                                }}>
                                    <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', color: '#4A5568' }}>بيانات الربط البرمجي (API Config)</h4>
                                    <p style={{ fontSize: '12px', color: '#718096', marginBottom: '12px' }}>
                                        أدخل الإعدادات بصيغة JSON (مثال: مفاتيح الـ API لـ Tabby أو PayPal)
                                    </p>
                                    <textarea
                                        value={typeof editingMethod.config === 'object' ? JSON.stringify(editingMethod.config, null, 2) : editingMethod.config || ''}
                                        onChange={(e) => setEditingMethod({ ...editingMethod, config: e.target.value })}
                                        placeholder='{ "publicKey": "...", "secretKey": "..." }'
                                        style={{
                                            width: '100%',
                                            height: '120px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #DDD',
                                            fontFamily: 'monospace',
                                            fontSize: '13px',
                                            direction: 'ltr'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                    <button type="submit" style={{ flex: 1, backgroundColor: '#3FB984', color: '#FFF', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>حفظ التغييرات</button>
                                    <button type="button" onClick={() => setEditingMethod(null)} style={{ flex: 1, backgroundColor: '#EDF2F7', color: '#4A5568', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>إلغاء</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {isAdding && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}>
                        <div style={{
                            backgroundColor: '#FFF',
                            borderRadius: '16px',
                            padding: '24px',
                            width: '500px',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                        }}>
                            <h2 style={{ fontFamily: 'El Messiri', marginBottom: '20px', color: '#2B2F3F' }}>إضافة وسيلة دفع جديدة</h2>
                            <form onSubmit={handleSaveNew} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>الاسم (عربي)</label>
                                        <input
                                            type="text"
                                            value={newMethod.displayNameAr}
                                            onChange={(e) => setNewMethod({ ...newMethod, displayNameAr: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            placeholder="مثال: التحويل البنكي"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>الاسم (إنجليزي)</label>
                                        <input
                                            type="text"
                                            value={newMethod.displayNameEn}
                                            onChange={(e) => setNewMethod({ ...newMethod, displayNameEn: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            placeholder="Example: Bank Transfer"
                                            required
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>النوع</label>
                                        <select
                                            value={newMethod.type}
                                            onChange={(e) => setNewMethod({ ...newMethod, type: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            required
                                        >
                                            <option value="CASH_ON_DELIVERY">CASH_ON_DELIVERY</option>
                                            <option value="PAYPAL">PAYPAL</option>
                                            <option value="CARD">CARD</option>
                                            <option value="APPLE_PAY">APPLE_PAY</option>
                                            <option value="TABBY">TABBY</option>
                                            <option value="TAMARA">TAMARA</option>
                                            <option value="BANK_TRANSFER">BANK_TRANSFER</option>
                                            <option value="OTHER">OTHER</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>الترتيب</label>
                                        <input
                                            type="number"
                                            value={newMethod.displayOrder}
                                            onChange={(e) => setNewMethod({ ...newMethod, displayOrder: e.target.value })}
                                            style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                            required
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>أيقونة (URL)</label>
                                    <input
                                        type="text"
                                        value={newMethod.icon}
                                        onChange={(e) => setNewMethod({ ...newMethod, icon: e.target.value })}
                                        style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #DDD' }}
                                        placeholder="رابط أيقونة الوسيلة"
                                    />
                                </div>

                                <div style={{
                                    marginTop: '4px',
                                    padding: '16px',
                                    backgroundColor: '#F9FAFB',
                                    borderRadius: '12px',
                                    border: '1px dashed #CBD5E0'
                                }}>
                                    <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', color: '#4A5568' }}>بيانات الربط البرمجي (API Config)</h4>
                                    <textarea
                                        value={newMethod.config}
                                        onChange={(e) => setNewMethod({ ...newMethod, config: e.target.value })}
                                        placeholder='{ "instruction": "يرجى التحويل إلى حساب رقم..." }'
                                        style={{
                                            width: '100%',
                                            height: '100px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #DDD',
                                            fontFamily: 'monospace',
                                            fontSize: '13px',
                                            direction: 'ltr'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                    <button type="submit" style={{ flex: 1, backgroundColor: '#3FB984', color: '#FFF', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>إضافة الوسيلة</button>
                                    <button type="button" onClick={() => setIsAdding(false)} style={{ flex: 1, backgroundColor: '#EDF2F7', color: '#4A5568', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>إلغاء</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
            <ToastContainer />
        </div>
    );
};

export default إعداداتطرقالدفع;
